import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ButtonProps } from "react-bootstrap/Button";
import { FaFilter } from "react-icons/fa";

import "./styles.scss";

type Props = ButtonProps;

export function ApplyFilterButton({ ...rest }: Props) {
	return (
		<OverlayTrigger overlay={<Tooltip>Aplicar filtros</Tooltip>}>
			<button
				id="apply-filter-button"
				className="btn btn-primary text-light py-2 px-3 fs-6"
				{...rest}
			>
				<span className="apply-filter-button-text">Aplicar filtros</span>

				<div className="apply-filter-button-icon-container">
					<FaFilter />
				</div>
			</button>
		</OverlayTrigger>
	);
}
